<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="taskHeader" class="page-name color-71aa3f">
                        Create Resale
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backshowtask">Back</button>
                </div>
                <div v-if="isDataEditable == true">
                    <div class="admin-page-content">
                        <form id="resaleform">
                            <div class="forms-container">
                                <div class="row no-margin">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span>Resale Added Successfully</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-danger" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg" class="error"></span>
                                        </div>
                                    </div>


                                    <div class="col-md-6 col-sm-12">
                                      <!-- CUSTOMER -->
                                      <div class="col-12 forms-block">
                                          <div class="col-3 paddingleft0">
                                              <div class="form-label"><strong>Customer</strong></div>
                                          </div>
                                          <div class="col-9 paddingleft0">
                                              <v-select v-model="customer_id"
                                              @change="changedValue" name="customer_id"
                                                        label="text"
                                                        :filterable="false"
                                                        :options="customerArr"
                                                        @search="onSearch"
                                                        v-validate="'required'"
                                                        placeholder="Select Customer">
                                                  <template slot="no-options">
                                                      Search Customers...
                                                  </template>
                                                  <template slot="option" slot-scope="option">
                                                      <div class="d-center">
                                                          {{ option.text }}
                                                      </div>
                                                  </template>
                                                  <template slot="selected-option" slot-scope="option">
                                                      <div class="selected d-center">
                                                          {{ option.text }}
                                                      </div>
                                                  </template>
                                              </v-select>
                                              <div class="requiredstar">*</div>
                                              <span v-show="errors.has('customer_id')" class="help is-danger" v-if="errors.has('customer_id')"><font color="red">Customer is Required</font></span>
                                          </div>
                                      </div>

                                      <!-- PART TAX -->
                                      <div class="col-12 forms-block">
                                          <div class="col-3 paddingleft0">
                                              <div class="form-label"><strong>Excede Tax Code (Parts)</strong></div>
                                          </div>
                                          <div class="col-9 paddingleft0">
                                              <v-select v-model="ptTaxId"
                                                    name="ptTaxId"
                                                        label="TaxId"
                                                        :filterable="false"
                                                        :options="taxArrArr"
                                                        v-validate="'required'"
                                                        @search="onSearchTax"
                                                        placeholder="Select Tax Code">
                                                  <template slot="no-options">
                                                      Search Tax Code...
                                                  </template>
                                                  <template slot="option" slot-scope="option">
                                                      <div class="d-center">
                                                          {{ option.Des }} - {{ option.TaxId }}
                                                      </div>
                                                  </template>
                                                  <template slot="selected-option" slot-scope="option">
                                                      <div class="selected d-center">
                                                          {{ option.Des }} - {{ option.TaxId }}
                                                      </div>
                                                  </template>
                                              </v-select>
                                              <div class="requiredstar">*</div>
                                              <span v-show="errors.has('ptTaxId')" class="help is-danger" v-if="errors.has('ptTaxId')"><font color="red">Tax Code is Required</font></span>
                                          </div>
                                      </div>

                                      <!-- SERVICE TAX -->
                                      <div class="col-12 forms-block">
                                          <div class="col-3 paddingleft0">
                                              <div class="form-label"><strong>Excede Tax Code (Service)</strong></div>
                                          </div>
                                          <div class="col-9 paddingleft0">
                                              <v-select v-model="svTaxId"
                                                    name="svTaxId"
                                                        label="TaxId"
                                                        :filterable="false" :options="taxArrArr"
                                                        v-validate="'required'"
                                                        @search="onSearchTax"
                                                        placeholder="Select Tax Code">
                                                  <template slot="no-options">
                                                      Search Tax Code...
                                                  </template>
                                                  <template slot="option" slot-scope="option">
                                                      <div class="d-center">
                                                          {{ option.Des }} - {{ option.TaxId }}
                                                      </div>
                                                  </template>
                                                  <template slot="selected-option" slot-scope="option">
                                                      <div class="selected d-center">
                                                          {{ option.Des }} - {{ option.TaxId }}
                                                      </div>
                                                  </template>
                                              </v-select>
                                              <div class="requiredstar">*</div>
                                              <span v-show="errors.has('svTaxId')" class="help is-danger" v-if="errors.has('svTaxId')"><font color="red">Tax Code is Required</font></span>
                                          </div>
                                      </div>

                                      <div class="desktol-created-data col-md-6 col-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created By</strong> : {{ firstName }} {{ lastName }}</div>
                                            </div>
                                      </div>
                                      <div v-if="is_update"  class="desktol-created-data col-md-6 col-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated By</strong> : {{ u_firstName }} {{ u_lastName }}</div>
                                            </div>
                                      </div>
                                      <div class="desktol-created-data col-md-6 col-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created at</strong> : {{ created_at }}</div>
                                            </div>
                                      </div>
                                      <div v-if="is_update"  class="desktol-created-data col-md-6 col-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated at</strong> : {{ updated_at }}</div>
                                            </div>
                                      </div>

                                    </div>


                                    <div class="col-md-6 col-sm-12">
                                        <!-- STATE -->
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Resale State</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select v-model="resale_state"
                                                      name="resale_state"
                                                          label="BrnIdState"
                                                          :filterable="false" :options="stateArr"
                                                          v-validate="'required'"
                                                          placeholder="Select State">
                                                    <template slot="no-options">
                                                        Search Resale State...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.BrnIdState }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.BrnIdState }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('resale_state')" class="help is-danger" v-if="errors.has('resale_state')"><font color="red">Resale State is Required</font></span>
                                            </div>
                                        </div>

                                        <!-- REASON -->
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Resale Reason</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select
                                                    name="resale_reason"
                                                    v-model="resale_reason"
                                                    id="resale_reason" label="SettingValue"
                                                    :options="reasonArr"
                                                    :required="true"
                                                    :value="resale_reason"
                                                    v-validate="'required'"
                                                    placeholder="Select Resale Reason"
                                                    ></v-select>
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('resale_reason')" class="help is-danger" v-if="errors.has('resale_reason')"><font color="red">Resale Reason is Required</font></span>
                                            </div>
                                        </div>

                                        <!-- OTHER -->
                                        <template v-if="resale_reason.SettingValue == 'Other'">
                                          <div class="col-12 forms-block">
                                              <div class="col-3 paddingleft0">
                                                  <div class="form-label"><strong>Other Reason</strong></div>
                                              </div>
                                              <div class="col-9 paddingleft0">
                                                  <input type="text" id="other_reason" name="other_reason" class="form-control"
                                                        placeholder="Enter Reason" v-model="other_reason"
                                                        v-validate="'required'">
                                                  <div class="requiredstar">*</div>
                                                  <span v-if="errors.has('other_reason')" v-show="other_reason == ''" class="help is-danger"><font color="red">Other Reason is required</font></span>
                                              </div>
                                          </div>

                                        </template>

                                        <!-- NUMBER -->
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Resale Number</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="resale_no" name="resale_no" class="form-control"
                                                      placeholder="Enter Resale Number" v-model="resale_no">
                                                <!--v-validate="'required|max:190'">-->
                                                <!--div class="requiredstar">*</div>
                                                <span v-if="errors.has('resale_no')" v-show="resale_no == ''" class="help is-danger"><font color="red">Resale Number is required</font></span-->
                                                <!--<span v-if="errors.firstByRule('subject','max')" v-show="subject != ''" class="help is-danger"><font color="red">Subject maximum length must be 190 characters</font></span>-->
                                            </div>
                                        </div>


                                        <!-- EXP DATE -->
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Resales Expiration Date</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="date" id="exp_date" name="exp_date" class="form-control"
                                                      placeholder="Enter Date in MM/DD/YYYY" v-model="exp_date">
                                                <!--div class="requiredstar">*</div>
                                                <span v-show="errors.has('exp_date')" class="help is-danger" v-if="errors.has('exp_date')"><font color="red">Resales Expiration Date is Required</font></span-->
                                            </div>
                                        </div>

                                        <!-- VERF DATE -->
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Resale <!-- State  -->Verification Date</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="date" id="verf_date" name="verf_date" class="form-control"
                                                      placeholder="Enter Date in MM/DD/YYYY" v-model="verf_date">
                                                <!--div class="requiredstar">*</div>
                                                <span v-show="errors.has('verf_date')" class="help is-danger" v-if="errors.has('verf_date')"><font color="red">Resale State Verification Date is Required</font></span-->
                                            </div>
                                        </div>

                                    </div>




                                    <div class="col-md-6 col-sm-12">
                                        <div class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created By</strong> : {{ firstName }} {{ lastName }}</div>
                                            </div>
                                        </div>


                                        <div class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created at</strong> : {{ created_at }}</div>
                                            </div>
                                        </div>



                                        <div v-if="is_update" class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated By</strong> : {{ u_firstName }} {{ u_lastName }}</div>
                                            </div>
                                        </div>


                                        <div v-if="is_update" class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated at</strong> : {{ updated_at }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 ml-3">
                                        <div class="col-12 paddingleft0">
                                            <input id="addTaskBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="AddResale()">
                                            <!-- <button style="float: left" id="addCaseBtn" type="submit" class="btn general-button btn-primary" v-on:click.prevent="addCase">{{btn}}</button> -->
                                            <!--input id="addAndContinueTaskBtn" type="submit" value="Save and Continue" class="btn general-button btn-primary" v-on:click.prevent="AddResale(flag='Save and Continue')"-->
                                            <input id="CancelTask" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backshowtask">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div v-if="isDataEditable == false" >
                    <div class="admin-page-content">
                        <div class="col-md-12 error-detail-main forms-container">
                            <div class="error-template">
                                <h1>Oops!</h1>
                                <!--<h2>403</h2>-->
                                <div class="error-details">Sorry You can't Edit This Record...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import index from "../../router";
    import Vue from "vue";
    import EventBus from "../event-bus";
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from "vee-validate";
    import SessioMixin from '../../mixins/sessionmixin';
    Vue.use(VeeValidate);
// import moment from 'moment'
    /* Vue FlatPickr */
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    var segments = "";
    var contex;
    export default {
        name: "AddResale",
        components: {
            'app-footer': FrontFooter,
            flatPickr,
        },
        mixins: [SessioMixin],
        data() {
            return {
                tempReason: '',
                is_update: false,
                created_at: '',
                updated_at: '',
                other_reason: '',
                ptTaxId: '',
                svTaxId: '',
                resale_no: '',
                resale_reason: '',
                exp_date: "",
                verf_date: "",
                resale_state: '',
                taxArrArr: [],
                stateArr: [],
                // reasonArr: [
                //   {"text" : "Government sales: Muni/School/Church"},
                //   {"text" : "Interstate Commerce"},
                //   {"text" : "CA Farm Exemption"},
                //   {"text" : "CA Mfg Exemption"},
                //   {"text" : "Other"},
                // ],
                reasonArr: [],

                isShowLoggedinfields: true,
                firstName: "",
                lastName: "",
                u_firstName: "",
                u_lastName: "",
                userName: "",
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                customerId: 0,
                created_by: "",
                updated_by: "",
                config: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'm/d/Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    enableTime: false,
                    //locale: Hindi, // locale for this instance only
                },
                priority: {value: "normal", text: "Normal"},
                status: {value: "open", text: "Open"},
                subject: "",
                description: "",

                priorityArr: [
                    {
                        value: "high",
                        text: "High"
                    },
                    {
                        value: "normal",
                        text: "Normal"
                    },
                    {
                        value: "low",
                        text: "Low"
                    }
                ],
                statusArr: [
                    {
                        value: "open",
                        text: "Open"
                    },
                    {
                        value: "in_progress",
                        text: "In Progress"
                    },
                    {
                        value: "closed",
                        text: "Closed"
                    }
                ],

                due_date: "",
                customer_id: "",
                options: "",
                customerArr: [],
                user_id: "",
                userArr: [],
                isDataEditable: true,
                loginID: ""
            };
        },
        watch: {
            customer_id: function (customer_id) {
                var self = this;

                if(customer_id != null && customer_id != '') {

                  // self.getTax(self.customer_id.sv_tax_id, "sv");
                  // self.getTax(self.customer_id.pt_tax_id, "pt");
                  console.log("selected customer ", self.customer_id);
                  if('sv_tax_id' in self.customer_id) {


                    console.log("sv_tax_id ", self.customer_id.sv_tax_id);
                    self.getTax(self.customer_id.sv_tax_id, "sv");
                    self.getTax(self.customer_id.pt_tax_id, "pt");

                    self.resale_no = self.customer_id.ssn;
                    console.log(self.resale_no);
                    self.exp_date = self.customer_id.date_birth_spouse;
                    if(self.customer_id.ssn_spouse != null) {
                      self.resale_state = {
                        "BrnIdState": self.customer_id.ssn_spouse
                      };

                    }

                  } else {

                  }

                }


                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[2] != 'update') {
                    if (typeof (customer_id) == "undefined" || customer_id == null) {
                        self.user_id = {value: '', text: ''};
                    } else {
                        if (typeof (customer_id.pt_tax_id) == "undefined" || customer_id.pt_tax_id == null) {
                            // console.log(customer_id.pt_tax_id);
                        } else {
                            // self.getTax(atob(customer_id.pt_tax_id), "pt");
                        }
                        if (typeof (customer_id.sv_tax_id) == "undefined" || customer_id.sv_tax_id == null) {
                            // console.log(customer_id.sv_tax_id);
                        } else {
                            // self.getTax(atob(customer_id.sv_tax_id), "sv");
                        }
                        if (customer_id == '') {
                            self.user_id = {value: '', text: ''};
                        } else {
                            $.ajax({
                                url: process.env.ROOT_API + "/get/customer/user",
                                type: "GET",
                                headers: {
                                    Accept: "application/json",
                                    "Access-Control-Allow-Origin": "*",
                                    Authorization: "Bearer " + localStorage.getItem("api_token"),
                                    "Access-Control-Allow-Headers":
                                            "Origin, Content-Type, Authorization,X-Requested-With",
                                    "Cache-Control": "no-cache"
                                },
                                data: {
                                    customer_id: customer_id.value
                                },
                                dataType: "json",
                                success: function (data) {
                                    if (customer_id.value) {
                                        self.user_id = {value: data[0].value, text: data[0].text};
                                        self.userArr = data;
                                    }
                                },
                                error: function (jqXHR, exception) {
                                    if (jqXHR.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        if (jqXHR.status == 401) {
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            self.$router.push("/login");
                                        }
                                        self.error = jqXHR.responseJSON.message;
                                    }
                                }
                            });
                        }
                    }
                }
            }
        },
        beforeMount: function () {
            var app = this;
            contex = this;
            var check = localStorage.getItem("api_token");

            if (check != null) {
                app.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            self.loadState();
            self.loadReason();
            $(".removeActive").removeClass("active");
            if (segments[2] == 'update') {
              self.is_update = true;
                if (segments[4] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menuresale").addClass("active");
                }
            } else {
                self.created_at = self.getCurrentDateTime('');
                //console.log(segments[3]);
                if (segments[3] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menuresale").addClass("active");
                }

                self.resale_reason = {
                  SettingValue: "Resale Exemption",
                };
            }

            if (localStorage.getItem("menu_small") == "1") {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            if (segments[2] == 'update') {
                if (segments[3]) {
                    self.showLoader();
                    self.loadTask();
                    // $("#addAndContinueTaskBtn").prop('disabled',true);
                    $("#addAndContinueTaskBtn").hide();
                    $("#addTaskBtn").val("Update");
                    $("#taskHeader").text("Edit Resale");
                }
            } else {
                if (segments[3] != 0) {
                    self.customerId = segments[3];
                    self.loadCustomeradd();
                    // console.log(atob(this.$route.query.sv));
                    // self.getTax(atob(this.$route.query.sv), "sv");
                    // self.getTax(atob(this.$route.query.pt), "pt");
                }
                self.resale_reason = {
                  SettingValue: "Resale Exemption",
                };
            }

            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit(
                        "logged-in",
                        false,
                        userJson["first_name"],
                        userJson["last_name"],
                        userJson["email"]
                        );
            }


        },
        methods: {
            getCurrentDateTime(givenDate) {
              // console.log('givenDate==', givenDate);
              if(givenDate == '') {
                var today = new Date();
              } else {
                var today = new Date(givenDate);
              }


                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                var HH = today.getHours();
                var MM = today.getMinutes();
                var SS = today.getSeconds();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }

                if(HH<10)
                {
                    HH='0'+HH;
                }

                if(MM<10)
                {
                    MM='0'+MM;
                }

                if(SS<10)
                {
                    SS='0'+SS;
                }

                var date = mm+'-'+dd+'-'+yyyy;
                var time = HH + ":" + MM + ":" + SS;

                today = date + " " + time;
                return today;
            },
            onDateChage(selectedDates, dateStr, instance) {
                var self = this;
                //console.log("Date Change Called : " + self.due_date);
            },
            onPickerClose() {
                var self = this;
                //console.log("Picker Close Called : " + self.due_date);
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_task') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            changedValue: function (value) {
                //console.log(value);
            },

            onSearch(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.loadCustomer(loading, search, this);
                }
            },
            onSearchTax(search, loading) {
                var self = this;
                if (search.length >= 1) {
                    loading(true);
                    self.loadTax(loading, search, this);
                }
            },
            onSearchState(search, loading) {
                var self = this;
                if (search.length > 1) {
                    loading(true);
                    self.loadState(loading, search, this);
                }
            },
            onSearchUser(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.loadUser(loading, search, this);
                }
            },
            loadCustomer(loading, search, vm) {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.customerArr = data;

                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadState() {
              // resale/taxlist
              var self = this;


                $.ajax({
                    url: process.env.ROOT_API + "/resale/state",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: ""
                    },
                    dataType: "json",
                    success: function (data) {
                        // loading(false);
                        self.stateArr = [];

                        self.stateArr = data;

                        /* console.log(self.stateArr); */
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            loadReason() {
              // resale/taxlist
              var self = this;


                $.ajax({
                    url: process.env.ROOT_API + "/resale/reason",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: ""
                    },
                    dataType: "json",
                    success: function (data) {
                        // loading(false);
                        self.reasonArr = [];

                        self.reasonArr = data;

                        self.reasonArr.push({'SettingValue' : "Other"})


                        var idx = self.reasonArr.findIndex(obj => obj.SettingValue == self.tempReason);
                        console.log("IDX ==", idx);

                        if(idx != -1) {
                          self.resale_reason = {
                            SettingValue: self.tempReason,
                          };
                        } else {

                          if(self.tempReason != "") {
                            self.resale_reason = {
                              SettingValue: "Other",
                            };
                            self.other_reason = self.tempReason;
                          }


                        }

                        // console.log(self.reasonArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            getTax(search, to) {
              var self = this;
              $.ajax({
                    url: process.env.ROOT_API + "/resale/taxlist",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        // console.log(data);
                        // loading(false);

                        self.taxArrArr = [];

                        self.taxArrArr = data.content;

                        if(to == 'sv') {
                          self.svTaxId = {
                                TaxId: data.content[0].TaxId,
                                Des: data.content[0].Des
                            };
                        } else {
                          self.ptTaxId = {
                                TaxId: data.content[0].TaxId,
                                Des: data.content[0].Des
                            };
                        }

                        // console.log(self.taxArrArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            loadTax(loading, search, vm) {
              // resale/taxlist
              var self = this;


                $.ajax({
                    url: process.env.ROOT_API + "/resale/taxlist",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        // console.log(data);
                        loading(false);

                        self.taxArrArr = [];

                        self.taxArrArr = data.content;

                        // console.log(self.taxArrArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadCustomeradd() {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        default: self.customerId
                    },
                    dataType: "json",
                    success: function (data) {
                        self.customer_id = {value: data[0].value, text: data[0].text};
                        self.customerArr = data;


                        self.getTax(data[0].sv_tax_id, "sv");
                        self.getTax(data[0].pt_tax_id, "pt");

                        self.resale_no = data[0].ssn;
                        console.log(self.resale_no);
                        self.exp_date = data[0].date_birth_spouse;
                        if(data[0].ssn_spouse != null) {
                          self.resale_state = {
                            "BrnIdState": data[0].ssn_spouse
                          };

                        }

                        // console.log(self.customerArr.data());
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },



            loadUser(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get/users",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search,
                        type: 'collector',
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);

                        self.userArr = data;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            backshowtask() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[2] == 'update') {
                    if (segments[4] != 0) {
                        self.$router.push("/customer/view/" + segments[4]);
                    } else {
                        self.$router.push("/resale/list");
                    }
                } else {
                    if (segments[3] != 0) {
                        self.$router.push("/customer/view/" + segments[3]);
                    } else {
                        self.$router.push("/resale/list");
                    }
                }
            },

            AddResale(flag) {
                var self = this;
                self.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        //console.log(segments[3]);
                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                //console.log(segments[3]);
                                $("#addTaskBtn").val("Updating ...");
                                $("#addTaskBtn").prop("disabled", true);
                                // $("#addAndContinueCaseBtn").prop('disabled',true);
                                $("#CancelTask").prop("disabled", true);
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueTaskBtn").val("Saving ...");
                                    $("#addAndContinueTaskBtn").prop("disabled", true);
                                    $("#addTaskBtn").prop("disabled", true);
                                    $("#CancelTask").prop("disabled", true);
                                } else {
                                    $("#addTaskBtn").val("Saving ...");
                                    $("#addTaskBtn").prop("disabled", true);
                                    $("#addAndContinueTaskBtn").prop("disabled", true);
                                    $("#CancelTask").prop("disabled", true);
                                }
                            }
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueTaskBtn").val("Saving ...");
                                $("#addAndContinueTaskBtn").prop("disabled", true);
                                $("#addTaskBtn").prop("disabled", true);
                                $("#CancelTask").prop("disabled", true);
                            } else {
                                $("#addTaskBtn").val("Saving ...");
                                $("#addTaskBtn").prop("disabled", true);
                                $("#addAndContinueTaskBtn").prop("disabled", true);
                                $("#CancelTask").prop("disabled", true);
                            }
                        }

                        var fields = $("#resaleform").serializeArray();
                        fields.push({name: "resale_reason", value: self.resale_reason.SettingValue});
                        fields.push({name: "customer_id", value: self.customer_id.value});
                        fields.push({name: "user_id", value: self.user_id.value});
                        fields.push({name: "ptTaxId", value: self.ptTaxId.TaxId });
                        fields.push({name: "ptTaxDes", value: self.ptTaxId.Des});
                        fields.push({name: "svTaxId", value: self.svTaxId.TaxId});
                        fields.push({name: "svTaxDes", value: self.svTaxId.Des });
                        fields.push({name: "resale_state", value: self.resale_state.BrnIdState});

                        fields.push({name: "date_birth_spouse", value: self.customer_id.date_birth_spouse});
                        fields.push({name: "date_birth", value: self.customer_id.date_birth});
                        fields.push({name: "ssn_spouse", value: self.customer_id.ssn_spouse});
                        fields.push({name: "ssn", value: self.customer_id.ssn});
                        // fields.push({name: "user_id", value: self.ptTaxId.id});
                        self.$validator.validateAll();
                        self.$validator.errors.clear();
                        if (segments[2] == 'update') {
                            if (segments[3]) {
                                fields.push({name: "id", value: segments[3]});
                            } else {
                                fields.push({name: "id", value: 0});
                            }
                        } else {
                            fields.push({name: "id", value: 0});
                        }
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/resale/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Access-Control-Allow-Headers":
                                        "Origin, Content-Type, Authorization,X-Requested-With",
                                "Cache-Control": "no-cache"
                            },
                            dataType: "json",
                            success: function (data) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addTaskBtn").val("Update");
                                        $("#addTaskBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelTask").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueTaskBtn").val("Save and Continue");
                                            $("#addAndContinueTaskBtn").prop("disabled", false);
                                            $("#addTaskBtn").prop("disabled", false);
                                            $("#CancelTask").prop("disabled", false);
                                        } else {
                                            $("#addTaskBtn").val("Save");
                                            $("#addTaskBtn").prop("disabled", false);
                                            $("#addAndContinueTaskBtn").prop("disabled", false);
                                            $("#CancelTask").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueTaskBtn").val("Save and Continue");
                                        $("#addAndContinueTaskBtn").prop("disabled", false);
                                        $("#addTaskBtn").prop("disabled", false);
                                        $("#CancelTask").prop("disabled", false);
                                    } else {
                                        $("#addTaskBtn").val("Save");
                                        $("#addTaskBtn").prop("disabled", false);
                                        $("#addAndContinueTaskBtn").prop("disabled", false);
                                        $("#CancelTask").prop("disabled", false);
                                    }
                                }
                                if (data.status == "success") {
                                    // self.$router.push('/task/list');

                                    if (flag == "Save and Continue") {
                                        $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").parent().removeClass("hide");
                                        $(".alert-success").parent().addClass("show");
                                        self.other_reason= '';
                                        self.ptTaxId= '';
                                        self.svTaxId= '';
                                        self.resale_no= '';
                                        self.resale_reason= '';
                                        self.exp_date= '';
                                        self.verf_date= '';
                                        self.resale_state= '';
                                        self.customer_id = '';
                                        self.user_id = '';
                                        self.customerArr = [];
                                        self.userArr = [];
                                        //$("#due_date").val("");
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        setTimeout(function () {
                                            $(".alert-success").parent().removeClass("show");
                                            $(".alert-success").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        self.backshowtask();
                                    }
                                } else {
                                    // $(".alert-danger").parent().removeClass('hide');
                                    // $(".alert-danger").parent().addClass('show');
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        $("#addTaskBtn").val("Update");
                                        $("#addTaskBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelTask").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueTaskBtn").prop("disabled", false);
                                            $("#addAndContinueTaskBtn").val("Save and Continue");
                                            $("#addTaskBtn").prop("disabled", false);
                                            $("#CancelTask").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            self.other_reason= '';
                                            self.ptTaxId= '';
                                            self.svTaxId= '';
                                            self.resale_no= '';
                                            self.resale_reason= '';
                                            self.exp_date= '';
                                            self.verf_date= '';
                                            self.resale_state= '';
                                            self.customer_id = '';
                                            self.user_id = '';
                                            self.customerArr = [];
                                            self.userArr = [];
                                            //$("#due_date").val("");
                                            if (segments[3] != 0) {
                                                self.customerId = segments[3];
                                                self.loadCustomeradd();
                                            }
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addTaskBtn").val("Save");
                                            $("#addTaskBtn").prop("disabled", false);
                                            $("#addAndContinueTaskBtn").prop("disabled", true);
                                            $("#CancelTask").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }

                                        if (jqXHR.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (jqXHR.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueTaskBtn").prop("disabled", false);
                                        $("#addAndContinueTaskBtn").val("Save and Continue");
                                        $("#addTaskBtn").prop("disabled", false);
                                        $("#CancelTask").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        self.other_reason= '';
                                        self.ptTaxId= '';
                                        self.svTaxId= '';
                                        self.resale_no= '';
                                        self.resale_reason= '';
                                        self.exp_date= '';
                                        self.verf_date= '';
                                        self.resale_state= '';
                                        self.customer_id = '';
                                        self.user_id = '';
                                        self.customerArr = [];
                                        self.userArr = [];
                                        if (segments[3] != 0) {
                                            self.customerId = segments[3];
                                            self.loadCustomeradd();
                                        }
                                        //$("#due_date").val("");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addTaskBtn").val("Save");
                                        $("#addTaskBtn").prop("disabled", false);
                                        $("#addAndContinueTaskBtn").prop("disabled", true);
                                        $("#CancelTask").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }

                                    if (jqXHR.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (jqXHR.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            }
                        });
                    }
                });
            },

            loadTask() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/resale/" + segments[3],
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        // if (data.content.created_by == self.loginID) {

                          self.created_at = self.getCurrentDateTime(data.content.created_at);;
                          self.updated_at = self.getCurrentDateTime(data.content.updated_at);

// TaxId: data.content.pt_tax_id.split("-")[1],
                            self.ptTaxId = {
                                TaxId: data.content.pt_tax_id,
                                Des: data.content.pt_tax_des,
                            };
                            self.svTaxId = {
                                TaxId: data.content.sv_tax_id,
                                Des: data.content.sv_tax_des
                            };
                            self.resale_no = data.content.resale_number;
                            console.log("reasonArr ==", self.reasonArr);

                            if(self.reasonArr.length > 0) {

                              var idx = self.reasonArr.findIndex(obj => obj.SettingValue == data.content.reason);
                              console.log("IDX ==", idx);

                              if(idx != -1) {
                                self.resale_reason = {
                                  SettingValue: data.content.reason,
                                };
                              } else {

                                self.resale_reason = {
                                  SettingValue: "Other",
                                };
                                self.other_reason = data.content.reason;

                              }

                            } else {
                              self.tempReason = data.content.reason;
                            }



                            // self.other_reason = data.content.reason;
                            //$("#due_date").val(data.content[0].due_date);
                            self.exp_date = data.content.resale_exp_date;
                            self.verf_date = data.content.resale_state_verify_date;
                            self.resale_state = {"BrnIdState": data.content.state};
                            self.customer_id = {
                                value: data.content.cid,
                                text: data.content.first_name + " (" + data.content.cusid + ")"
                            };
                            self.user_id = {
                                value: data.content.uid,
                                text:
                                        data.content.user_firstname +
                                        " " +
                                        data.content.user_lastname/* +
                                         " - " +
                                         data.content[0].user_email*/
                            };

                            // console.log(data.content.updated_user_firstname);
                            self.u_firstName = data.content.updated_user_firstname;
                            self.u_lastName = data.content.updated_user_lastname;

                            // self.isDataEditable = true;
                        // } else {
                        //     // self.isDataEditable = false;
                        // }
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $(".opensidebar").show();
                $(".closesidebar").hide();
                $(".menu").addClass("menusmall");
                $(".sidemenu li a span,.legal").addClass("displaynone");
                $(".sidemenu li a i").addClass("displayicons");
                $(".sidebar").css({width: "70px"});
                $(".content").css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $(".opensidebar").hide();
                $(".closesidebar").show();
                $(".menu").removeClass("menusmall");
                $(".sidemenu li a span,.legal").removeClass("displaynone");
                $(".sidemenu li a i").removeClass("displayicons");
                $(".sidebar").css({width: "260px"});
                $(".content").css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
        }
    };
    EventBus.$on('logged-in', function (isLogin, fname, lname, email) {
        if (typeof (contex) != "undefined") {
            contex.isShowLoggedinfields = isLogin;
            contex.firstName = fname;
            contex.lastName = lname;
            contex.userName = email;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/resale/AddResale.vue